const breadCrumb = "Lotação de Servidores - Diretores e Secretários";

const routes = [
  {
    path: "/exonerar-diretor-e-secretario/:id",
    name: "exonerar-diretor-e-secretario",
    meta: {
      allowedPermissions: ["parametro_periodo_remocao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ExonerarDiretorESecretario/ExonerarDiretorESecretario.vue"
      ),
  },
];

export default routes;
